export enum OnboardingStep {
  OnboardingForm = "OnboardingForm",
  LoginForm = "LoginForm",
  RegisterForm = "RegisterForm",
  ForgotPINForm = "ForgotPINForm",
  BankAccountForm = "BankAccountForm",
  NameForm = "NameForm",
  ForgotPasswordForm = "ForgotPasswordForm",
}
